module.exports = __webpack_public_path__ + "components/rewards/insurance/static/logo-e3183e42490cdc7be1525d7c00329be4.jpg";